import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { APP_URL, USERSROLE } from 'types';
import ListBox from 'carbon-components-react/lib/components/ListBox';
import { Link } from 'carbon-components-react';
import { ChevronUp16 } from '@carbon/icons-react';
import { useComponentMount } from 'utilities/hooks.util';

const adminRole: Array<string> = [USERSROLE.ORGADMIN, USERSROLE.MANAGER];

const MoreActionsPanel: React.FC<Props> = ({
  showAutoRenewItem,
  showEnableAutoRenew,
  showDuplicateItem,
  onClose,
  onAutoRenewingClick,
  onEnquiryEditClick,
  enquiryId,
  isArchive,
  moreActionPos,
  confirmationPdfId,
  viewAttachment,
  uploadAttachment,
  archiveEnquiry,
  onMoveEnquiryToTeamClick,
  userRole,
  isAutoRenew,
  enquiryAutoRenewSeries,
  archiveSeriesHandler,
  userId,
  enquiryUserId
}) => {
  const history = useHistory();
  const panelOffsetHeightRef = useRef<number>(0);
  const [panelHeight, setPanelHeight] = useState<number>(0);
  const canEdit =
    (userRole && adminRole.includes(userRole)) || enquiryUserId === userId;
  const showMoveEnquiryMenuItem =
    (userRole && adminRole.includes(userRole)) ||
    (userRole === 'User' && enquiryUserId === userId);

  const panelRef = (el: HTMLDivElement | null) => {
    if (el) {
      panelOffsetHeightRef.current = el.offsetHeight;
    }
  };
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleAutoRenewingClick = () => {
    onAutoRenewingClick();
    onClose();
  };

  const handleEnquiryEditClick = () => {
    onEnquiryEditClick();
    onClose();
  };

  const handlearchiveEnquiry = (enquiryId: number, isArchive: boolean) => {
    if (isAutoRenew && enquiryAutoRenewSeries?.length > 1) {
      archiveSeriesHandler(isArchive);
      onClose();
    } else {
      archiveEnquiry(enquiryId, [], isArchive);
      onClose();
    }
  };

  const handleUploadLinkClick = () => {
    fileInputRef.current && fileInputRef.current.click();
  };

  const handleMoveEnquiryToTeamClick = () => {
    onMoveEnquiryToTeamClick();
    onClose();
  };

  const onUploadFileChange = (
    evt: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const target = evt.target;
    if (target.files) {
      uploadAttachment(id, target.files[0]);
    }
    onClose();
  };

  useComponentMount(() => {
    panelOffsetHeightRef.current &&
      setPanelHeight(panelOffsetHeightRef.current);
  });

  return (
    <>
      <div className="more-actions-overlay" onClick={() => onClose()}></div>
      <div
        className="more-actions-panel"
        ref={panelRef}
        style={{ top: moreActionPos[0] - panelHeight, left: moreActionPos[1] }}
      >
        <ListBox className="bx--combo-box" isOpen={true}>
          <ListBox.Menu
            id="more-actions-list-menu"
            className="more-actions-list-menu"
          >
            {(showAutoRenewItem || showEnableAutoRenew) && (
              <ListBox.MenuItem onClick={() => handleAutoRenewingClick()}>
                {showAutoRenewItem && !showEnableAutoRenew
                  ? 'Auto-renew properties'
                  : 'Enable auto-renew'}
              </ListBox.MenuItem>
            )}
            {canEdit && (
              <ListBox.MenuItem onClick={handleEnquiryEditClick}>
                Edit enquiry properties
              </ListBox.MenuItem>
            )}

            {showMoveEnquiryMenuItem && (
              <ListBox.MenuItem onClick={handleMoveEnquiryToTeamClick}>
                Move enquiry to team
              </ListBox.MenuItem>
            )}
            <ListBox.MenuItem onClick={handleUploadLinkClick}>
              Upload a document
            </ListBox.MenuItem>
            {showDuplicateItem && (
              <ListBox.MenuItem
                onClick={() =>
                  history.push({
                    pathname: APP_URL.NEW_ENQUIRY,
                    state: {
                      duplicateFrom: String(enquiryId)
                    }
                  })
                }
              >
                Duplicate enquiry
              </ListBox.MenuItem>
            )}
            {canEdit && (
              <ListBox.MenuItem
                onClick={() => handlearchiveEnquiry(enquiryId, isArchive)}
              >
                {isArchive ? 'Archive' : 'Restore'} enquiry
              </ListBox.MenuItem>
            )}
          </ListBox.Menu>
        </ListBox>
      </div>
      <div
        className="more-actions-section"
        style={{ top: moreActionPos[0], left: moreActionPos[1] }}
      >
        {confirmationPdfId && (
          <div className="confirmation-link-container">
            <Link onClick={() => viewAttachment(confirmationPdfId)}>
              BYDA confirmation
            </Link>
          </div>
        )}
        <div className="more-actions-link-container">
          <Link onClick={() => onClose()}>
            More actions
            <ChevronUp16 />
          </Link>
        </div>
      </div>
      <input
        type="file"
        className="bx--visually-hidden"
        ref={fileInputRef}
        onChange={(evt) => onUploadFileChange(evt, enquiryId)}
      />
    </>
  );
};

type Props = {
  showAutoRenewItem: boolean;
  showEnableAutoRenew: boolean;
  showDuplicateItem: boolean;
  onAutoRenewingClick: Function;
  onEnquiryEditClick: Function;
  onClose: Function;
  enquiryId: number;
  isArchive: boolean;
  moreActionPos: number[];
  confirmationPdfId?: number;
  viewAttachment: Function;
  uploadAttachment: Function;
  archiveEnquiry: Function;
  onMoveEnquiryToTeamClick: Function;
  userRole?: string;
  isAutoRenew: boolean;
  enquiryAutoRenewSeries: any[];
  archiveSeriesHandler: Function;
  userId: number;
  enquiryUserId: number;
};

export default React.memo(MoreActionsPanel);
